<template>
      <div class='footer'>
        <div class="copyright">
Copyright © 2010-2026 <a href="https://www.zhonghegroup.com">众合云科</a>
<br/>
<a target="_blank" rel="noopener noreferrer"
 class="govportal" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502055553">
      <img src="../assets/gov_portal.png"  style="height:20px;" alt="备案信息" />京公网安备11010502055553号</a>
<a href="https://beian.miit.gov.cn" rel="noopener noreferrer nofollow" target="_blank">京ICP备2022011708号-18</a>
        </div>

    </div>
</template>
<script>
  export default {
    name: "footerHtml",
    data() {
          return {
              // isHead: this.$store.state.isHeadTip,
          }
    },
    props: {

    },
    created(){
        // this.qimo();
    }
        //
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.footer{
    min-width: 1200px;
    padding:30px 0;
    background: #F4F4F5;
    overflow: hidden;
  }
  .copyright{
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #7F828E;
    letter-spacing: 0;
    text-align: center;
    line-height: 22px;
    a{
      font-size: 14px;
      color: #7F828E;
    }
    a:hover{
      color:#056EFB;
    }
  }
  .govportal{
    position: relative;
    padding-left: 26px;

  }
  .govportal img{
    display: block;
    width: 20px;
    height: 20px;
    position:absolute;
    top:-1px;
    left:0px;
  }

</style>



// WEBPACK FOOTER //
// src/components/footer_html.vue